import axios from 'axios';

let Common = {};

Common.ajax = axios.create({
  baseURL: '/',
  // timeout: 30000,
  withCredentials: true
});

Common.ajax.interceptors.request.use(config => {
  config.headers.xreferer = window.location.href
  return config
}, error => {
  console.log(error)
  Promise.reject(error)
})

Common.ajax.interceptors.response.use(
  response => {
    const res = response
    if (res.data.code === 200) {
      return res
    } else {
      return Promise.reject('error')
    }
  },
  error => {
    const errorResponse = error.response
    Message({
      message: errorResponse.data.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(errorResponse)
  }
)

export default Common;



// WEBPACK FOOTER //
// ./src/config/common.js